import React, { useEffect, useState } from "react";
import AlertMessage, { AlertLevel } from "./AlertMessage";
import { useAppSelector } from "../app/hooks";
import KeyValuePair from "../interfaces/keyValuePair";

interface Props {
	className?: string;
	alerts?: Record<number, string>;
}

export function clearDismissedBroadcastAlerts() {
	for (let [key, value] of Object.entries(localStorage)) {
		if (key.startsWith("session-dismissable-banner-alert")) {
			localStorage.removeItem(key);
		}
	}
}

export default function BroadcastAlerts(props: Props) {
	const userId = useAppSelector((state) => state.user.userId);
	const [alerts, setAlerts] = useState<KeyValuePair<string, string>[]>([]);

	function hash(s: string) {
		let ret = 23;
		for (let i = 0; i < s.length; i++) {
			ret = (ret * 17 + s.charCodeAt(i)) | 0;
		}
		return String(ret);
	}

	function initAlerts(alerts: Record<number, string> | undefined) {
		const alertKvps: KeyValuePair<string, string>[] = [];
		if (alerts) {
			for (const [key, value] of Object.entries(alerts)) {
				const storageKey = getStorageKey(userId, key);
				const storageValue = hash(value);
				if (localStorage.getItem(storageKey) != storageValue) {
					alertKvps.push({ key, value });
				}
			}
		}
		return alertKvps;
	}

	useEffect(() => {
		setAlerts(initAlerts(props.alerts));
	}, [props.alerts]);

	const handleClear = (alertId: string | undefined, message: string | null | undefined) => {
		const storageKey = getStorageKey(userId, alertId);
		const storageValue = hash(message ?? "");
		localStorage.setItem(storageKey, storageValue);

		const index = alerts.findIndex((a) => a.key === alertId);
		if (index >= 0) {
			alerts.splice(index, 1);
			setAlerts([...alerts]);
		}
	};

	if (alerts.length === 0) return null;

	return (
		<section className={props.className}>
			{alerts.map((a) => (
				<AlertMessage
					key={a.key}
					alertId={a.key}
					message={a.value}
					className="mb-4"
					type={AlertLevel.Warning}
					showIcon={false}
					onClear={handleClear}
				/>
			))}
		</section>
	);
}

export function getStorageKey(userId: number | null, key: string | undefined) {
	// Search for "session-dismissable-banner" in the MVC code
	return `session-dismissable-banner-alert-${userId}-${key}`;
}

export function restoreAlertforSession(userId: number | null, id: number) {
	if (!userId) return;
	const key = getStorageKey(userId, id.toString());
	localStorage.removeItem(key);
}
